import { getFeatureConfig } from '@luna/feature-config';

type ProductWithSelfServicing = {
    flags?: string[];
    features?: string[];
};

const SELF_SERVICE_FEATURE = 'selfService';
const SELF_SERVICE_FLAG = 'selfServiceAllowed';

export const isFlagAndFeatureDrivenSelfServicing = ({
    flags = [],
    features = [],
}: ProductWithSelfServicing) => {
    if (!getFeatureConfig(({ products }) => products.flagAndFeatureDrivenSelfServicing)) {
        return true;
    }

    return features?.includes(SELF_SERVICE_FEATURE) && flags.includes(SELF_SERVICE_FLAG);
};
